// extracted by mini-css-extract-plugin
module.exports = {"w10oesj0":"w10oesj0"};